var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":function($event){return _vm.launchFilePicker()}}},[_vm._t("activator")],2),_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file","name":_vm.uploadFieldName},on:{"change":function($event){return _vm.onFileChange(
        $event.target.name, $event.target.files)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }